import { render, staticRenderFns } from "./Tpv.vue?vue&type=template&id=23c5e19c"
import script from "./Tpv.vue?vue&type=script&lang=js"
export * from "./Tpv.vue?vue&type=script&lang=js"
import style0 from "./Tpv.vue?vue&type=style&index=0&id=23c5e19c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports